import { FC, useCallback, useLayoutEffect, useRef } from 'react';

import { IonDatetime } from '@ionic/react';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormDateValidation, DatetHighlightCallback } from './FormDate.types';
import { defaultHighlightedDates } from './FormDate.utils';
import inline from './FormDate.css?inline';

import styles from './FormDate.module.scss';

interface FormDateProps extends FormControlBaseProps<FormDateValidation> {
  min?: string;
  max?: string;
  size?: 'cover' | 'fixed';
  isDateEnabled?: (dateIsoString: string) => boolean;
  highlightedDates?: DatetHighlightCallback;
}

export const FormDate: FC<FormDateProps> = ({
  disabled,
  min,
  max,
  isDateEnabled,
  size = 'cover',
  highlightedDates: initialHighlightedDates = defaultHighlightedDates,
  ...props
}) => {
  const datetime = useRef<HTMLIonDatetimeElement>();

  const highlightedDates = useCallback(
    (date: string) => {
      if (initialHighlightedDates(date)) {
        return {
          textColor: 'var(--color-brown-400)',
          backgroundColor: 'var(--color-periwinkle-100)',
        };
      }
    },
    [initialHighlightedDates]
  );

  useLayoutEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = inline;
    datetime.current.shadowRoot.appendChild(style);
  }, []);

  return (
    <FormControl variant="default" type="date" {...props}>
      {({ value = '', onChange, onBlur }) => {
        return (
          <IonDatetime
            size={size}
            ref={datetime}
            className={styles.datetime}
            disabled={disabled}
            highlightedDates={highlightedDates}
            isDateEnabled={isDateEnabled}
            max={max}
            min={min}
            onIonBlur={onBlur}
            onIonChange={onChange}
            presentation="date"
            value={value}
          />
        );
      }}
    </FormControl>
  );
};
